import { StrappingEnum } from 'api';

export const formatStrapping = (strapping: StrappingEnum): string => {
  switch (strapping) {
    case StrappingEnum.bale_wires:
      return 'Bale wires';
    case StrappingEnum.metal_straps:
      return 'Metal straps';
    case StrappingEnum.not_banded:
      return 'Not banded';
    case StrappingEnum.plastic_sheet:
      return 'Plastic sheet';
    case StrappingEnum.plastic_wrap:
      return 'Plastic wrap';
    case StrappingEnum.ropes:
      return 'Ropes';
    case StrappingEnum.straps:
      return 'Straps';
    case StrappingEnum.pp_bags:
      return 'PP Bags with plastic wrap';
    default:
      return '';
  }
};
